import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowUpRight, Check } from 'lucide-react';
import Reveal from '../components/Reveal';
import { SERVICES, SECTORS } from '../data/mock';

export default function ServiceDetail() {
  const { id } = useParams();
  const s = SERVICES.find((x) => x.id === id);
  if (!s) return <Navigate to="/services" replace />;
  const other = SERVICES.find((x) => x.id !== id);

  return (
    <div className="bg-[var(--bg)]">
      {/* Hero */}
      <section className="pt-36 pb-12">
        <div className="container-rs">
          <span className="section-index"><span className="coral-dot" /> Services / {s.code} — {s.tag}</span>
          <Reveal>
            <h1 className="font-display text-7xl md:text-[150px] leading-[0.92] mt-6">{s.title}<span className="text-[var(--coral)]">.</span></h1>
          </Reveal>
          <div className="grid md:grid-cols-12 gap-8 mt-10">
            <p className="md:col-span-7 md:col-start-6 text-[18px] md:text-[20px] text-[var(--ink-mute)] leading-relaxed">{s.long}</p>
          </div>
        </div>
      </section>

      {/* Hero image */}
      <section className="py-10">
        <div className="container-rs">
          <div className="overflow-hidden rounded-3xl">
            <img src={s.image} alt={s.title} className="w-full h-[480px] md:h-[680px] object-cover" />
          </div>
        </div>
      </section>

      {/* What we do */}
      <section className="py-24">
        <div className="container-rs grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <span className="section-index"><span className="coral-dot" /> What we do</span>
            <h2 className="font-display text-4xl md:text-6xl mt-6 leading-[0.95]">A complete <span className="font-display-italic text-[var(--coral)]">scope.</span></h2>
          </div>
          <div className="md:col-span-7 md:col-start-6 grid sm:grid-cols-2 gap-6">
            {s.bullets.map((b, i) => (
              <Reveal key={b} delay={i * 60} className="flex items-start gap-4 p-6 soft-card tilt">
                <div className="w-10 h-10 rounded-full bg-[var(--coral)]/10 text-[var(--coral)] flex items-center justify-center shrink-0"><Check size={16} /></div>
                <div>
                  <div className="font-display text-xl">{b}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Sectors */}
      <section className="py-24 bg-[var(--bg-soft)]">
        <div className="container-rs">
          <span className="section-index"><span className="coral-dot" /> Sectors served</span>
          <h2 className="font-display text-5xl md:text-7xl mt-6 leading-[0.95]">Where this team <span className="font-display-italic text-[var(--coral)]">delivers.</span></h2>
          <div className="mt-12 flex flex-wrap gap-3">
            {SECTORS.map((sector) => (
              <span key={sector} className="px-6 py-4 rounded-full bg-white border border-[var(--line)] hover:border-[var(--coral)] hover:text-[var(--coral)] transition-colors text-[14px] font-medium">{sector}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Other service CTA */}
      <section className="py-24 bg-[var(--navy)] text-white">
        <div className="container-rs grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-7">
            <span className="section-index text-white/70"><span className="coral-dot" /> Also from the studio</span>
            <h3 className="font-display text-4xl md:text-6xl mt-4 leading-[0.95]">{other.title}<span className="font-display-italic text-[var(--coral)]">.</span></h3>
            <p className="mt-5 opacity-80 max-w-2xl">{other.short}</p>
          </div>
          <div className="md:col-span-4 md:col-start-9 flex md:justify-end gap-3 flex-wrap">
            <Link to={`/services/${other.id}`} className="pill pill-outline-light"><span>{other.title}</span><ArrowUpRight size={14} /></Link>
            <Link to="/contact" className="pill pill-coral"><span>Brief us</span><ArrowUpRight size={14} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
